(function () {
    'use strict';
    a3_pilot_reports.factory('AnnualLeavesFactory', AnnualLeavesFactory);

    /**
     * @memberof PilotReports
     * @ngdoc factory
     * @name AnnualLeavesFactory
     * @description 
     *    Get Annual Leaves Data 
     * @ngInject
     */
    function AnnualLeavesFactory(GenericService, $http, apiUrl) {

        /**
         * Initialize the AnnualLeaves
         * @memberof CheckInFactory
         */
        function AnnualLeaves() {

        }

        var objType = 'AnnualLeaves';
        var objCallback = AnnualLeaves;

        var service = {
            setAnnualLeavesToStorage: setAnnualLeavesToStorage,
            getAnnualLeavesToStorage: getAnnualLeavesToStorage
        }
    
        /**
        * Save Annual Leaves
        * @param {array} annualLeavesInInfo 
        */
        function setAnnualLeavesToStorage(annualLeavesInInfo) {
            if (annualLeavesInInfo == undefined || annualLeavesInInfo == null) {
                GenericService.removeAll(objType);
            }
            else {             
                GenericService.saveAll(annualLeavesInInfo, objType, objCallback);
            }
        }


        /**
        * Gets annual leaves
        * @returns {annualLeavesObj} annualLeavesObj
        */
        /**
         * Get annual leaves
         */
        function getAnnualLeavesToStorage() {
            return GenericService.list(objType, objCallback);;
        }

        return service;
    }

})();